import type { GameMode, Language } from '@business-game/shared';

export const SESSION_GAME_MODE_OPTIONS: Array<{
  value: GameMode;
  label: string;
  subtitle: string;
}> = [
  { value: 'teamlab', label: 'Team Lab', subtitle: 'Standard' },
  { value: 'leadlab', label: 'Lead Lab', subtitle: 'Dimension RSE' },
];

export const SESSION_LANGUAGE_OPTIONS: Array<{ value: Language; label: string; countryCode: string }> = [
  { value: 'fr', label: 'Français', countryCode: 'FR' },
  { value: 'en', label: 'English', countryCode: 'GB' },
  { value: 'es', label: 'Español', countryCode: 'ES' },
  { value: 'de', label: 'Deutsch', countryCode: 'DE' },
  { value: 'nl', label: 'Nederlands', countryCode: 'NL' },
  { value: 'pt', label: 'Português', countryCode: 'PT' },
];

export const SESSION_TIMEZONE_OPTIONS = [
  'Europe/Paris',
  'Europe/Brussels',
  'Europe/Zurich',
  'Europe/London',
  'UTC',
  'Africa/Casablanca',
  'Africa/Abidjan',
  'Africa/Lagos',
  'Africa/Cairo',
  'Africa/Nairobi',
  'Africa/Johannesburg',
  'America/New_York',
  'America/Montreal',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Mexico_City',
  'America/Bogota',
  'America/Santiago',
  'America/Sao_Paulo',
  'America/Argentina/Buenos_Aires',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Bangkok',
  'Asia/Singapore',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Australia/Sydney',
  'Pacific/Auckland',
] as const;

export type SessionTimezone = (typeof SESSION_TIMEZONE_OPTIONS)[number];

export const timezoneShortLabel = (timezone: string): string => {
  const parts = timezone.split('/');
  return parts[parts.length - 1]?.replace(/_/g, ' ') ?? timezone;
};

export const formatTimezoneOffset = (timezone: string): string => {
  try {
    const formatter = new Intl.DateTimeFormat('fr-FR', {
      timeZone: timezone,
      timeZoneName: 'shortOffset',
    });
    return formatter.formatToParts(new Date()).find((part) => part.type === 'timeZoneName')?.value ?? '';
  } catch {
    return '';
  }
};
